import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "max-w-2lg mx-auto p-6 bg-white rounded-lg items-center",
  style: {"background":"radial-gradient(circle at 50% -50%, #dff9f0, #dff9f0, #e0f9f0, #e2faf1, #e5faf3, #ebfbf6, #f3fdf9, #f9fefc, #fcfffe, #feffff, #ffffff, #ffffff)"}
}
const _hoisted_2 = { class: "max-w-lg mx-auto py-16" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-semibold text-center mb-4" }, "Bekleme Listesine Katıl", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 text-center mb-4" }, "E-posta adresinizi girerek erken erişim kazanın!", -1)
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        class: "space-y-4"
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          required: "",
          placeholder: "E-posta adresiniz",
          class: "w-full p-3 border rounded-full focus:ring focus:ring-blue-200"
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "w-full rounded-full bg-secondary px-3.5 py-2 font-semibold text-primary shadow-sm hover:bg-teal-50 hover:text-secondary hover:border-secondary hover:ring-4 hover:ring-secondary focus:ring-4 focus:outline-none focus:ring-secondary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900",
          disabled: _ctx.loading
        }, _toDisplayString(_ctx.loading ? 'Gönderiliyor...' : 'Bekleme Listesine Katıl'), 9, _hoisted_5),
        (_ctx.message)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass([{'text-green-600': _ctx.success, 'text-red-600': !_ctx.success}, "text-center mt-2"])
            }, _toDisplayString(_ctx.message), 3))
          : _createCommentVNode("", true)
      ], 32)
    ])
  ]))
}